import state from './state'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'

export const AUTH_STORE_NAME = 'auth'

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
